<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3212_101614)">
<mask id="path-1-inside-1_3212_101614" fill="white">
<rect y="8" width="6" height="6" rx="1"/>
</mask>
<rect y="8" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2.8" mask="url(#path-1-inside-1_3212_101614)"/>
<rect x="8.62501" y="9.00398" width="0.85" height="3.99199" stroke="currentColor" stroke-width="0.85"/>
<rect x="12.1" y="8.57898" width="1.7" height="4.84199" fill="currentColor"/>
<mask id="path-4-inside-2_3212_101614" fill="white">
<rect x="16" y="8" width="6" height="6" rx="1"/>
</mask>
<rect x="16" y="8" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2.8" mask="url(#path-4-inside-2_3212_101614)"/>
</g>
<defs>
<clipPath id="clip0_3212_101614">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
